import { Dispatch } from 'redux';
import { ActionTypes, ReduxAction } from './types';
import { AuftragsvorlageService } from '../../api';
import httpSearchQueue from '../../config/HttpSearchQueue';

export const searchAuftragsvorlage =
  (
    searchParam: string,
    page?: number,
    searchLimit?: number,
    mandantId?: number
  ) =>
  async (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.LOADING,
      payload: true,
    });
    httpSearchQueue
      .add(new AuftragsvorlageService().searchAuftragsvorlage, [
        searchParam,
        page,
        searchLimit,
        mandantId,
      ])
      .then(response => {
        dispatch({
          type: ActionTypes.SET_TOTALSEARCHRESULTS,
          payload: response.headers['total-search-results'],
        });
        dispatch({
          type: ActionTypes.SEARCH_AUFTRAGSVORLAGE,
          payload: response.data,
        });
        dispatch({
          type: ActionTypes.LOADING,
          payload: false,
        });
      });
  };

export const setVorlageAuftragId =
  (id: number) => (dispatch: Dispatch<ReduxAction>) => {
    dispatch({
      type: ActionTypes.SET_VORLAGE_AUFTRAG_ID,
      payload: id,
    });
  };

export const deleteAuftragsvorlage =
  (id: number) => async (dispatch: Dispatch<ReduxAction>) => {
    new AuftragsvorlageService().deleteAuftragsvorlage(id).then(() => {
      dispatch({
        type: ActionTypes.RELOAD_AUFTRAGSVORLAGE_MANAGEMENT,
      });
    });
  };
